export const language = function () {
  return [
    { text: 'English', value: 'en_US' },
    { text: '中文', value: 'zh_CN' },
    { text: '日本語', value: 'ja_JP' }
  ]
}

export const defaultLanguage = function () {
  return 'en_US'
}
